import React, { useRef } from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"
import styles from "./index.module.scss"
import { useDeviceType } from "@/hooks/useDeviceType"

/* Carousel block displayed at right side */
const CarouselBlock = ({ slidesToShow, images }) => {
  const imageDeck = images.map(img => img.fields.imageUrl)
  const slides = [...imageDeck, ...imageDeck, ...imageDeck]
  const middlePoint = imageDeck.length
  const sliderRef = useRef(null)

  const settings = {
    slidesToShow,
    slidesToScroll: 1,
    infinite: false,
    initialSlide: middlePoint,
    speed: 500,
    arrows: false,
    dots: false,
    
  slidesToShow: 2.4, 
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2.4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4
      }
    },
     {
      breakpoint: 400,
      settings: {
        slidesToShow: 2
      }
    }
  ]
,
    beforeChange: (_old, newIndex) => {
      if (newIndex < middlePoint) {
        setTimeout(() => {
          sliderRef.current?.slickGoTo(newIndex + imageDeck.length, true)
        }, 520)
      } else if (newIndex >= middlePoint + imageDeck.length) {
        setTimeout(() => {
          sliderRef.current?.slickGoTo(newIndex - imageDeck.length, true)
        }, 520)
      }
    },
  }

  return (
    <div className={styles["left-kc-carousel-block"]}>
      <div className={styles["left-kc-slider-wrap"]}>
        <Slider ref={sliderRef} {...settings}>
          {slides.map((slide, index) => {
            const originalImage = images[index % images.length]
            const caption = originalImage?.fields?.title
          return (
            <>
            
            <div key={index} className={styles["left-kc-slide"]}>
              <img
                src={slide}
                alt={`Slide ${(index % imageDeck.length) + 1}`}
              />
            </div>
            {caption && (
              <div>
                <p className={styles["left-kc-caption"]}>
                  {caption}
                </p>
              </div>
            )}
            </>
          )
    })}
        </Slider>
      </div>

      <button
        className={`${styles["left-kc-arrow"]} ${styles["left-prev"]}`}
        onClick={() => sliderRef.current?.slickPrev()}
        aria-label="Previous"
      >
        <svg width="15" height="35" viewBox="0 0 10 18" fill="none">
          <path
            d="M9 1L1 9L9 17"
            stroke="gray"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <button
        className={`${styles["left-kc-arrow"]} ${styles["left-next"]}`}
        onClick={() => sliderRef.current?.slickNext()}
        aria-label="Next"
      >
        <svg width="15" height="35" viewBox="0 0 10 18" fill="none">
          <path
            d="M1 1L9 9L1 17"
            stroke="gray"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  )
}

CarouselBlock.defaultProps = {
  slidesToShow: 2.4,
  images: [],
}

CarouselBlock.propTypes = {
  slidesToShow: PropTypes.number,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        imageUrl: PropTypes.string.isRequired,
      }),
    })
  ),
}

/* Text block displayed at left side */

const ThreeImageCarouselTextLeft = ({ threeImageCarouselData }) => {
  const {
    buttonText = "",
    description = "",
    images = [],
    subtitle = "",
    title = "",
    cta,
    greyBackGround = "#000"
  } = threeImageCarouselData
  const descriptionValue = description?.content?.[0]?.content?.[0]?.value
  const ctaFields = cta?.fields ?? {};
  const { label, url, ariaLabel="" } = ctaFields;
  return (
    <section className={styles["left-kc-section"]} style={{ backgroundColor: greyBackGround ? "#494949" : "#000" }}>
      <div className={styles["left-kc-root"]}>
        <div className={styles["left-kc-inner"]}>
          {title === 'Suite Design' ? (
          <div className={styles["kc-text-col"]}>
            {title && <p className={styles["kc-eyebrow"]}>{title}</p>}
            {subtitle && (
              <h1 className={styles["kc-title"]}>{subtitle}</h1>
            )}
            {descriptionValue && (
              <p className={styles["kc-body"]}>{descriptionValue}</p>
            )}
            {(buttonText || label) && (
              <a href={url} className={styles["kc-btn"]} aria-label={ariaLabel}>
                {buttonText || label}
              </a>
            )}
          </div> 
           ) : (
          <div className={styles["left-kc-left"]}>
            {title && <p className={styles["left-kc-subtitle"]}>{title}</p>}
            {subtitle && (
              <h1 className={styles["left-kc-title"]}>{subtitle}</h1>
            )}
            {descriptionValue && (
              <p className={styles["left-kc-body"]}>{descriptionValue}</p>
            )}
            {buttonText || label ? (
              <a href={url} className={styles["left-kc-btn"]} aria-label={ariaLabel}>
                {buttonText || label}
              </a>
            ) : null}
          </div>
        )}
          <div className={styles["left-kc-right"]}>
            <CarouselBlock  images={images} />
          </div>
        </div>

        <div className={styles["left-kc-mobile-slider"]}>
          <CarouselBlock images={images} />
        </div>
      </div>
    </section>
  )
}

ThreeImageCarouselTextLeft.defaultProps = {
  threeImageCarouselData: {},
}

ThreeImageCarouselTextLeft.propTypes = {
  threeImageCarouselData: PropTypes.object,
}

/* Carousel block displayed at left side */

const CarouselBlockRight = ({ slidesToShow, images }) => {
  const imageDeck = images.map(img => img.fields.imageUrl)
  const slides = [...imageDeck, ...imageDeck, ...imageDeck]
  const baseLength = imageDeck.length
  const middlePoint = baseLength
  const sliderRef = useRef(null)

  const settings = {
    slidesToShow,
    slidesToScroll: 1,
    infinite: false,
    initialSlide: middlePoint,
    speed: 500,
    arrows: false,
    dots: false,
    rtl: true,
    slidesToShow:2, 


  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2.4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4
      },
      
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2
      },
      
    }
  ],
    beforeChange: (_old, newIndex) => {
      if (newIndex < middlePoint) {
        setTimeout(
          () => sliderRef.current?.slickGoTo(newIndex + baseLength, true),
          520
        )
      } else if (newIndex >= middlePoint + baseLength) {
        setTimeout(
          () => sliderRef.current?.slickGoTo(newIndex - baseLength, true),
          520
        )
      }
    },
  }

  return (
    <div className={styles["kc-carousel-block"]}>
      <div
        className={styles["kc-slider-wrap"]}
        style={{ "--clip-offset": "80px" }}
      >
        <Slider ref={sliderRef} {...settings}>
          {slides.map((slide, index) => 
          {
            const originalImage = images[index % images.length]
            const caption = originalImage?.fields?.title

            return (
                      <div key={index} className={styles["kc-slide"]}>
                        <img src={slide} alt={`Slide ${(index % baseLength) + 1}`} />
                        {caption && (
                          <p className={styles["kc-caption"]}>
                            {caption}
                          </p>
                        )}
                      </div>
                )
              })}
        </Slider>
      </div>

      <button
        className={`${styles["kc-arrow"]} ${styles["prev"]}`}
        onClick={() => sliderRef.current?.slickPrev()}
        aria-label="Previous"
      >
        <svg width="15" height="35" viewBox="0 0 10 18" fill="none">
          <path
            d="M9 1L1 9L9 17"
            stroke="gray"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <button
        className={`${styles["kc-arrow"]} ${styles["next"]}`}
        onClick={() => sliderRef.current?.slickNext()}
        aria-label="Next"
      >
        <svg width="15" height="35" viewBox="0 0 10 18" fill="none">
          <path
            d="M1 1L9 9L1 17"
            stroke="gray"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  )
}

CarouselBlockRight.defaultProps = {
  slidesToShow: 3,
  images: [],
}

CarouselBlockRight.propTypes = {
  slidesToShow: PropTypes.number,
  images: CarouselBlock.propTypes.images,
}

/* Text block displayed at right side */

const ThreeImageCarouselTextRight = ({ threeImageCarouselData }) => {
  const {
    buttonText = "",
    description,
    images,
    subtitle,
    title,
    cta,
    greyBackGround = "#000"
  } = threeImageCarouselData
  const descriptionValue = description?.content?.[0]?.content?.[0]?.value;
  const ctaFields = cta?.fields ?? {};
  const { label, url, ariaLabel } = ctaFields;

  return (
    <section className={styles["kc-section"]}  style={{ backgroundColor: greyBackGround ? "#494949" : "#000" }}>
      <div className={styles["kc-root"]}>
        <div className={styles["kc-inner"]}>
          <div className={styles["kc-slider-col"]}>
            <CarouselBlockRight images={images} />
          </div>

          <div className={styles["kc-text-col"]}>
            <p className={styles["kc-eyebrow"]}>{title}</p>
            <h1 className={styles["kc-title"]}>{subtitle}</h1>
            <p className={styles["kc-body"]}>{descriptionValue}</p>
             {(buttonText || label) && (
              <a href={url} className={styles["kc-btn"]} aria-label={ariaLabel}>
                {buttonText || label}
              </a>
            )}
          </div>
        </div>

        <div className={styles["kc-mobile"]}>
          <div className={styles["kc-mobile-text"]}>
            <p className={styles["kc-eyebrow"]}>{title}</p>
            <h1 className={styles["kc-title"]}>{subtitle}</h1>
            <p className={styles["kc-body"]}>{descriptionValue}</p>
            {(buttonText || label) && (
              <a href={url} className={styles["kc-btn"]} aria-label={ariaLabel}>
                {buttonText || label}
              </a>
            )}
          </div>

          <div className={styles["kc-mobile-slider"]}>
            <CarouselBlockRight  images={images} />
          </div>
        </div>
      </div>
    </section>
  )
}

ThreeImageCarouselTextRight.defaultProps = {
  threeImageCarouselData: {},
}

ThreeImageCarouselTextRight.propTypes = {
  threeImageCarouselData: PropTypes.object,
}

/* Main wrapper component */

const ThreeImageCarousel = ({ threeImageCarouselData }) => {
  const { textPlacement = "left" } = threeImageCarouselData
  if (textPlacement === "left") {
    return (
      <ThreeImageCarouselTextLeft
        threeImageCarouselData={threeImageCarouselData}
      />
    )
  }
  return (
    <ThreeImageCarouselTextRight
      threeImageCarouselData={threeImageCarouselData}
    />
  )
}

ThreeImageCarousel.defaultProps = {
  threeImageCarouselData: {},
}

ThreeImageCarousel.propTypes = {
  threeImageCarouselData: PropTypes.object,
}

export default ThreeImageCarousel
